module.exports = __webpack_public_path__ + "img/ISTP.f72904cb.png";